var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6667 19.25H19.6133L19.24 18.8788C20.5918 17.2618 21.3348 15.1975 21.3333 13.0625C21.3333 11.2948 20.825 9.56686 19.8727 8.0971C18.9204 6.62733 17.5669 5.48179 15.9833 4.80533C14.3996 4.12887 12.6571 3.95188 10.9759 4.29674C9.29472 4.64159 7.75047 5.49281 6.53841 6.74274C5.32636 7.99267 4.50094 9.58518 4.16653 11.3189C3.83213 13.0526 4.00376 14.8496 4.65971 16.4827C5.31567 18.1159 6.4265 19.5117 7.85173 20.4938C9.27696 21.4758 10.9526 22 12.6667 22C14.8133 22 16.7867 21.1888 18.3067 19.8413L18.6667 20.2263V21.3125L25.3333 28.1738L27.32 26.125L20.6667 19.25ZM12.6667 19.25C9.34667 19.25 6.66667 16.4863 6.66667 13.0625C6.66667 9.63875 9.34667 6.875 12.6667 6.875C15.9867 6.875 18.6667 9.63875 18.6667 13.0625C18.6667 16.4863 15.9867 19.25 12.6667 19.25Z",
    fill: "#707070",
    fillOpacity: 0.96
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchicon);
export default __webpack_public_path__ + "static/media/search icon.ef3056e06ac28cd93409c1eaed266537.svg";
export { ForwardRef as ReactComponent };